<template>
  <b-modal
    id="create-case-list"
    :title="$translate('Create new case list')"
    hide-footer
    centered
    content-class="rounded-8"
    @hide="onClose"
  >
    <div class="row">
      <div class="col-12 col-lg-12 col-sm-12 col-xs-12">
        <Input
          v-model="name"
          form-group-id="caseListName"
          :placeholder="'Case list name' | i18n"
          required
        />
      </div>
      <div class="col-12 col-lg-12 col-sm-12 col-xs-12">
        <Multiselect
          :options="generalCaseList.map(({ id, title, caseNumberString }) => ({ value: id, text: `${title} (№ - ${caseNumberString})` }))"
          form-group-id="caseIds"
          placeholder="Cases"
          :placeholder-input="'Select cases' | i18n"
          :on-change="(v) => (idList = v)"
          required
          :init-values="idList"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-lg-12 col-sm-12 col-xs-12 d-flex justify-content-between mt-3">
        <b-button variant="outline-secondary" size="lg" class="btn-delete-device mr-3 px-55" @click="onClose">
          {{ 'cancel' | i18n }}
        </b-button>
        <b-button variant="outline-primary" size="lg" class="px-55" :disabled="!name || !idList.length" @click="onSubmit">
          {{ 'save' | i18n }}
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import Input from '../../common/input';
import Multiselect from '../../common/multiselect';
import api from '../../../api';
import { NotificationMixin } from '../../../../mixins';

export default {
  name: 'CreateCaseListModal',
  components: { Input, Multiselect },
  mixins: [NotificationMixin],
  props: {
    generalCaseList: {
      type: Array,
      default: () => [],
    },
    getPage: {
      type: Function,
      default: () => {},
    },
  },
  data: function () {
    return {
      name: '',
      idList: [],
    };
  },
  methods: {
    onClose() {
      this.onClear();
      this.$root.$emit('bv::hide::modal', 'create-case-list');
    },
    onClear() {
      this.name = '';
      this.idList = [];
    },
    async onSubmit() {
      try {
        const data = {
          name: this.name,
          idList: this.idList.map(({ value }) => value),
        };
        await api.caseLists.create(data);
        this.onClose();
        this.showNotification({ type: 'success', message: this.$translate('Case list was successfully created!') });
        this.onClear();
        this.getPage();
      } catch (error) {
        this.showNotification({ type: 'error', message: error.message });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .modal-header {
  border: none;
  padding-bottom: 0px !important;
}
.px-55 {
  padding-left: 55px;
  padding-right: 55px;
}
::v-deep .rounded-8 {
  border-radius: 8px;
}
::v-deep .btn-lg {
  font-size: 16px;
  line-height: 24px;
}
</style>
